import $ from 'jquery';
import async from 'async';
import './speedometer';
import {TUTIL,DATE_UTIL,_str,isNoDataError,sendAnalyticsInfo,software_use_events} from 'h2g-test-results/js/util';

 angular.module('speedTest', ['WTG.L'])
 .directive('wtgSpeedTest', function() {
  return {
   restrict: 'E',
   templateUrl: C11N.root_path +'speed-test/templates/speed-test.html',
   controller:'speedTestCtrl'
  };
 })
 .directive('wtgSpeedTestResults', function() {
  return {
   restrict: 'E',
   templateUrl: C11N.root_path +'speed-test/templates/speed-test-results.html',
   controller:'speedTestResultsCtrl'
  };
 })
 .factory("ST_PROGRESS",function(){
  var test_in_process = {
   engine_test_prog : false,
   evaluate_env : false,
   max_speed : 100,
   update_available: false,
   speed_test_res : {p2p:{dl:0.0,ul:0.0,s:true},line:{dl:0.0,ul:0.0,s:true},e2e:{dl:0.0,ul:0.0,s:true},wifi:{dl:0.0,ul:0.0,s:true},s:0,sa:"",sd:""}// 's" means status - 0 for done , 1 for progress , sa - server address, sd - server distance
  };
 return test_in_process;
 })
 .factory('SPEEDTESTDATA', function(L) {
  var st_results = {
   capabilities: {},
   testParams: {},
   peer_2_peer_test: false,
   history: false,
   st_results_ui:false,
   get_capabilities: function(open_history) {
    NativeAPI.speedtest_capabilities(function(e,r){
     st_results.peer_2_peer_test = false;
     st_results.history = open_history;
     if(e) L.error({err:e},"Error at getting  speedtest capabilities");
     L.trace("SPEEDTESTDATA.capabilities--r---"+JSON.stringify(r));
     if(r && Object.keys(r).length){
      st_results.capabilities = r;
      ShowScreen('SpeedTest');
     }
     else L.trace("speed test don't have any capabilities");
    });
   }
  };
  return st_results;
 })
 .factory('ST_UNITS', function(SPEEDTESTDATA,L){
   var st_units = {
    get_speed_Mbps : function (val){
     var v = SPEEDTESTDATA.capabilities.version;
     L.trace("speed test version --"+v);
     if(v && v>1) return (isNaN(val))?"":(val/1000000).toFixed(2);
     L.trace("speed test old app engine code");
     return (isNaN(val))?"":((val*8)/1000000).toFixed(2);
    }
   };
   return st_units;
 })
 .factory('ST_HISTORY', function($rootScope,L) {
  var st_history = {
   fetch_P2P_results : function (nw_id,devid,cb) {
    L.trace("fetch_P2P_results - nw_id - "+nw_id+", devid - "+devid);
    function retrieve_result(nwid,devices,cb2) {
     var res = {};
     async.forEach(devices, function(item, cb1) { // TODO: this should be a reduce
      //L.trace("devices parsing - "+item);
      get_json(`Network Devices.${nwid}.${item}.speedtest`,function(e,r) {
       if(isNoDataError(e)) return cb1();
       else if(e) cb1(e);
       else {
        //L.trace("data - e - "+JSON.stringify(e));
        //L.trace("data - r - "+JSON.stringify(r));
        Object.keys(r).forEach(function(key) {
         //L.trace("key - "+key);
         //L.trace("key - "+JSON.stringify(r[key]));
         res[key] = r[key];
         //L.trace("res - "+JSON.stringify(res));
        });
        // TODO: we should not be using different names for cbs, because we
        // want to make sure we aren't calling the callback from the outer
        // level
        cb1();
       }
      });
     },
     function(e/*,r*/) {
      cb2(e,res);
     });
    }
    function retrieve_devices(nwid,devid_it_is_not_used_by_the_way,cb) {
     retrieveData(`Networks.${nw_id}.speedtest.p2p`,"devices",'',function(e,r) {
      if(isNoDataError(e)) return cb();
      if(e) return cb(e);
      var devs = r && JSON.parse(r);
      if(!devs) return cb();
      cb(null,devs);
     });
    }
    if(nw_id && devid) return retrieve_result(nw_id,[devid],cb);
    get_json("Networks",function(e,r) {
     //L.trace("networks - e - "+JSON.stringify(e));
     //L.trace("networks - r - "+JSON.stringify(r));
     if(e) {
      L.warn({err:e},"error fetching networks for p2p speedtest history");
      return cb(e);
     }
     var p2p = {};
     async.forEachOf(r,function(nw,nwid,callback) {
      var devices = [];
       //L.trace("network id - "+nwid);
       retrieve_devices(nwid,devid,function(e,r) {
        if(!e && r) r.forEach(function(x) { devices.push(x)});
        retrieve_result(nwid,devices,function(e,r) {
         if(!e && r) {
          Object.keys(r).forEach(function(key) {
           //L.trace("key - "+key);
           //L.trace("key - "+JSON.stringify(r[key]));
           p2p[key] = r[key];
          });
         }
         callback();
        });
       });
     },function(/*e,r*/){
      /* TODO: this is a nest of bad practices: non-functional manipulating
       * outer state, ignoring errors, ignoring results… */
      //L.trace("p2p - "+JSON.stringify(p2p));
      cb(null,p2p);
     });
    });
   },
   processOldResults : function processOldResults(err,sth,cb) {
    if(err) return cb();
    var history=[];
    var sh = sth;
    for(var id in sth) {
     if((!sh[id].result)||(sh[id].result == 'prog')) continue;
     sh[id].ts_ = sh[id].ts_last || sh[id].ts;
     sh[id].id = id;
     history.push(sh[id]);
    }
    history.sort(function(a,b) { return (parseInt(b.ts_)-parseInt(a.ts_)) });
    cb(null,{history:history,olddata:true});
   },
   fetchOldResults: function(cb) {
    if(C11N.is_portal) $rootScope.get_json("test_results.tests.speed_test",function(err,sth) {
     st_history.processOldResults(err,sth,cb);
    });
    else get_json("test_results.tests.speed_test",function(err,sth) {
     st_history.processOldResults(err,sth,cb);
    });
   },
   fetch : function (cb) {
    if(!cb) return L.error("no callback for getSpeedTestHistory");
    //end_to_end_speedtest
    //line_speedtest
    //wifi_speedtest
    async.parallel({
     e2e: function(cb){
      if(C11N.is_portal) $rootScope.get_json("test_results.tests.end_to_end_speedtest",function(e,r) {
      if(e) return cb();
      cb(e,r);
      });
      else get_json("test_results.tests.end_to_end_speedtest",function(e,r){
       if(isNoDataError(e)) cb();
       else cb(e,r);
      });
     },
     line: function(cb){
      if(C11N.is_portal) $rootScope.get_json("test_results.tests.line_speedtest",function(e,r) {
      if(e) return cb();
      cb(e,r);
      });
      else get_json("test_results.tests.line_speedtest",function(e,r){
       if(isNoDataError(e)) cb();
       else cb(e,r);
       });
     },
     wifi: function(cb){
      if(C11N.is_portal) $rootScope.get_json("test_results.tests.wifi_speedtest",function(e,r) {
      if(e) return cb();
      cb(e,r);
      });
      else get_json("test_results.tests.wifi_speedtest",function(e,r) {
       if(isNoDataError(e)) cb();
       else cb(e,r);
      });
     },
     p2p: function(cb) {
      if(C11N.is_portal) return cb();
      st_history.fetch_P2P_results("","",function(e,r){
       if(isNoDataError(e)) cb();
       else cb(e,r);
      });
     }
    },function(e,res) {
    if(e) {
     L.error({err:e},"Error retrieving speed test results - e - "+JSON.stringify(e));
     st_history.fetchOldResults(cb);
    }
    if(res.e2e || res.line || res.wifi || res.p2p) return cb(null,res);
    L.trace("no new data results, check for old results");
    st_history.fetchOldResults(cb);
    });
   }
  };
  return st_history;
 })
 .controller('speedTestCtrl', function($scope, $rootScope,$timeout,ST_PROGRESS,WTGDIALOG,TESTRESULTS,SPEEDTESTDATA,ST_UNITS,L) {
  var speed_test_type = {
   peer_2_peer:"p2p",   // Test within local network (measuring wifi performance)
   line_speed:"line", // Test from router to some server on the internet (measuring provider performance)
   e2e_speed:"e2e",    // Test from device to outside (measuring everything end-to-end)
   wifi_speed:"wifi" // Test from device to router
  };
  var router_supported_status = 1;
  const status_msg = {
   0: "speed_test_router_detecting",
   1: "speed_test_router_supported",
   2: "speed_test_router_not_supported",
   3: "speed_test_router_turned_off"
  };
  var speednobe_id = {p2p : "#dial_hand_e2e",line :"#dial_hand_line",e2e:"#dial_hand_e2e",wifi:"#dial_hand_wifi"};
  $scope.multi_speed_test = true;
  var dial_hands = 1;
  $scope.cur_stt = {}; // current speed test type
  $scope.testParams = {};
  $scope.show_main_tab = true;
  $scope.st_hint = "" ;
  $scope.st_us_detailed_info = "" ;
  $scope.screen_link = "" ;
  $scope.click_here = _str("str_click_for_more_info");
  function load_content(){
     L.trace("speedtest_view enter--engine_test_prog-"+ST_PROGRESS.engine_test_prog );
     sendAnalyticsInfo({id:software_use_events.speed_test});
     $scope.capabilities = $scope.get_cap();
     $scope.st_usage_summary = "";
     $scope.st_hint = "";
     $scope.screen_link = "" ;
     $scope.st_us_detailed_info = "" ;
     $rootScope.hideBusyScreen();
     //$scope.router_con_status_update();
     $scope.orderByField = 'ts';
     $scope.reverseSort = true;
     $scope.is_wifi_test_failed = false;
     $scope.is_line_test_failed = false;
     $scope.str_wifi_test_failed = $rootScope.strings.str_speed_test_failed;
     $scope.str_line_test_failed = $rootScope.strings.str_speed_test_failed;
     $scope.download_result = 0;
     $scope.upload_result = 0;
     $scope.st_wifi_dl = "0.0";
     $scope.st_wifi_ul = "0.0";
     $scope.st_provider_dl = "0.0";
     $scope.st_provider_ul = "0.0";
     $scope.st_problem_summary = "";
     $scope.server_add = "";
     $scope.ser_dist = "";
     $scope.wifi = $rootScope.strings.str_wifi;
     $scope.line = $rootScope.strings.str_line;
     $scope.e2e_speed = $rootScope.strings.str_internet_speed;
     dial_hands = 1;
     var scale = prepare_speed_test_scale(50,1,300);
     if($scope.capabilities) {
      $scope.check_multi_speed_test_capability();
      $("#speed_meter").perform_speed_test({divFact:1,numbers:scale,maxVal:300,speedNobes:dial_hands,capabilities:Object.keys($scope.capabilities),gagueLabel:_str("speed_test_units_mbps")});
     }
     $scope.all_needles_to_default_state();
     if( ST_PROGRESS.engine_test_prog ) $scope.test_running_state();
     else{
      $scope.set_default_values();
      $("#test_in_process").hide();
     }
     if(SPEEDTESTDATA.peer_2_peer_test) $scope.runTest();
     if(!C11N.is_portal) {
      setStatusBarColor('main_ui');
      H2GAPP.setTitle(false,$rootScope.strings.speed_test_title);
     }
    }
  $scope.$on('$ionicView.enter', load_content);
  $scope.$on('$ionicView.leave', function(){
   _allow_swipe = true;
  });
  $scope.is_portal = C11N.is_portal;
  $scope.show_main_tab = true;
  $scope.loader = C11N.root_path +"speed-test/images/spin.gif";
  $scope.st_wifi = C11N.root_path +"speed-test/images/wifi.svg";
  $scope.st_line = C11N.root_path +"speed-test/images/home_internet.svg";
  $scope.st_infoIcon = C11N.root_path +"speed-test/images/ic_info.svg";
  $scope.str_speed_test = $rootScope.strings.speed_test_title;
  $scope.str_results = $rootScope.strings.speed_test_tab_title;
  $scope.download_icon = C11N.root_path + "speed-test/images/ic_download.svg";
  $scope.upload_icon = C11N.root_path + "speed-test/images/ic_upload.svg";
  //$scope.speed_test_units = "";
  $scope.speed_test_ui = !SPEEDTESTDATA.history;
  $scope.test_units =" "+_str("speed_test_units_mbps");
  $scope.test_btn = _str("id_run_test");
  $scope.server_add_label = _str("speed_test_server_label")+" ";
  $scope.server_dist_label = _str("speed_test_distance_label")+" ";
  $scope.isDisabled = false;
  $scope.slider_units = _str("speed_test_units_mbps");
  $scope.labels =[0,50,100,150,200,250,300];
  $scope.runTest = function(){
   var desc = $rootScope.strings.speed_test_data_consumption_warning;
   var result = TUTIL.get_test_result_data("mobile","mobile_connection_state");
   if(result && result.connected){
    WTGDIALOG.open_simple_dialog(WTGDIALOG.gen_popup, { header:  $rootScope.strings.alert , body: desc, btn_two:$rootScope.strings.cancel_btn, btn_one: $rootScope.strings.ok_btn,
    cb_two: function(){
     L.trace("speed test - NO");
    },
    cb_one: function(){
     if(ST_PROGRESS.update_available) $scope.refresh_screen(SPEEDTESTDATA.capabilities,function(){runSpeedTest()});
     else runSpeedTest();
    }
   });
  }else{
   if(ST_PROGRESS.update_available) $scope.refresh_screen(SPEEDTESTDATA.capabilities,function(){runSpeedTest()});
   else runSpeedTest();
  }
 };
 function runSpeedTest(){
  L.trace("run speed test - YES");
  sendAnalyticsInfo({id:software_use_events.run_speed_test});
  $("#st_retest_btn").addClass("disableBtn");
  if(SPEEDTESTDATA.capabilities.version){
   if(SPEEDTESTDATA.peer_2_peer_test){
    $scope.testParams = SPEEDTESTDATA.testParams;
    $scope.testParams.version = SPEEDTESTDATA.capabilities.version;
   }
   else $scope.testParams = SPEEDTESTDATA.capabilities;
  }
  else $scope.testParams.stt = $scope.capabilities && Object.keys($scope.capabilities) || [];
  var p= JSON.stringify($scope.testParams);
  L.trace("run_speed_test--"+p);
  if(!C11N.is_portal)performTest_Fix("speed_test",p||"");
  else $rootScope.runSpeedTest();
  Object.keys($scope.capabilities).forEach(function(k){
   $scope.cur_stt[k] = ($scope.capabilities[k].status == 1);
  });
  L.trace("cur_stt--"+JSON.stringify($scope.cur_stt));
  $scope.set_default_values();
  //			$(".sts_download_result").css({color: 'gray', opacity: 0.5});
  //			$(".sts_upload_result").css({color: 'gray', opacity: 0.5});
  $("#test_in_process").show();
  $scope.all_needles_to_default_state();
  ST_PROGRESS.engine_test_prog = true;
  ST_PROGRESS.speed_test_res.s = 1; //SPEEDTEST.test_done = false;
  $scope.download_result =0;
  $scope.upload_result = 0;
  $scope.st_wifi_dl = "0.0";
  $scope.st_wifi_ul = "0.0";
  $scope.st_provider_dl = "0.0";
  $scope.st_provider_ul = "0.0";
  $scope.st_problem_summary = "";
  $scope.st_usage_summary = "";
  $scope.st_hint = "";
  $scope.screen_link = "" ;
  $scope.st_us_detailed_info = "" ;
  $scope.server_add = "";
  $scope.ser_dist = "";
 }
 $scope.get_cap = function(){
  return SPEEDTESTDATA.peer_2_peer_test ? SPEEDTESTDATA.testParams.stt
        : (SPEEDTESTDATA.capabilities.version ? SPEEDTESTDATA.capabilities.stt :SPEEDTESTDATA.capabilities);
 };
 $scope.set_default_values = function(){
  ST_PROGRESS.speed_test_res = {p2p:{dl:0.0,ul:0.0,s:true},line:{dl:0.0,ul:0.0,s:true},e2e:{dl:0.0,ul:0.0,s:true},wifi:{dl:0.0,ul:0.0,s:true},s:0,sa:"",sd:""};
 };
 $scope.all_needles_to_default_state = function() {
  ["e2e","line","wifi","p2p"].forEach(function(id){$("#speed_meter").changePosition(0,"#dial_hand_"+id)});
 };
 $scope.set_line_speed_status = function(dl,ul,is_test_done,m) {
  $scope.is_line_test_failed = !is_test_done;
  $scope.st_provider_dl = dl;
  $scope.st_provider_ul = ul;
  if(m) $scope.str_line_test_failed = m;
  ST_PROGRESS.speed_test_res.line.s = is_test_done;
 };
 $scope.set_wifi_speed_status = function(dl,ul,is_test_done,m) {
  $scope.is_wifi_test_failed = !is_test_done;
  $scope.st_wifi_dl = dl;
  $scope.st_wifi_ul = ul;
  if(m) $scope.str_wifi_test_failed = m;
  ST_PROGRESS.speed_test_res.wifi.s = is_test_done;
 };
 $scope.set_total_internet_speed_status = function(dl,ul) {
  L.trace("set_total_internet_speed_status--"+dl+"--ul--"+ul);
  $scope.download_result = dl;
  $scope.upload_result = ul;
  $scope.test_units = " "+$rootScope.strings.speed_test_units_mbps;
 };
 $scope.set_server_data = function(server,dist) {
  $scope.server_add = server;
  $scope.ser_dist = dist && parseInt(dist)+" km" || "";
 };
 $scope.speed_test_fail = function(){
  $scope.isDisabled = false;
  $scope.test_btn = $rootScope.strings.id_test_again;
  $("#test_in_process").hide();
  ST_PROGRESS.engine_test_prog = false;
 };
 $scope.click_for_more_info = function(test){
  switch(test) {
   case "LocalScan":
    ShowScreen("DeviceList");
   break;
   case "wifi_optimizer":
    ShowScreen("wifichannels");
   break;
   case "wifi_measurements":
    ShowScreen("wifiMeasurement");
   break;
  }
 };
 $scope.show_results = function(){
   $scope.speed_test_ui = false;
   sendAnalyticsInfo({id:software_use_events.speed_test_results});
 };
 $scope.infoIconClick = function(){
  var result = TUTIL.get_test_result_data("mobile","mobile_connection_state");
  var desc = (result && result.connected)?_str("str_mobile_speed_test_info"):_str("str_speed_test_info");
  WTGDIALOG.open_simple_dialog(WTGDIALOG.gen_popup,{header: _str("alert"), body: desc, btn_one: _str("ok_btn")});
 };

 $scope.show_speed_test_screen = function(){
  $scope.speed_test_ui = true;
  $("#sts_speed_test").addClass("st_tab_select");
  $("#sts_results").removeClass("st_tab_select");
  if(ST_PROGRESS.engine_test_prog){
   $scope.test_running_state();
  }
  else{
   $scope.stop();
  }
 };
 $scope.setSpeedTestLabels = function(test) {
  if(!test) return;
  switch(test){
   case 'download':
   $(".sts_download_result").css({color: 'black', opacity: 1});
   break;
   case 'upload':
   $(".sts_upload_result").css({color: 'black', opacity: 1});
   break;
   default:
   $(".sts_download_result").css({color: 'gray', opacity: 0.5});
   $(".sts_upload_result").css({color: 'gray', opacity: 0.5});
   break;
  }
 };

 $scope.getPostfix = function(speed){
  return speed+" "+ $rootScope.strings.speed_test_units_mbps;
 };
 $scope.test_running_state = function maintain_last_state(){
  L.trace("test_running_state");
  $("#st_retest_btn").addClass("disableBtn");
  $scope.is_wifi_test_failed = !ST_PROGRESS.speed_test_res.wifi.s;
  $scope.is_line_test_failed = !ST_PROGRESS.speed_test_res.line.s;

  var st = ST_PROGRESS.speed_test_res;
  $scope.download_result = st[speed_test_type.e2e_speed].dl;
  $scope.upload_result = st[speed_test_type.e2e_speed].ul;
  $scope.st_wifi_dl = st[speed_test_type.wifi_speed].dl;
  $scope.st_wifi_ul = st[speed_test_type.wifi_speed].ul;
  $scope.st_provider_dl = st[speed_test_type.line_speed].dl;
  $scope.st_provider_ul = st[speed_test_type.line_speed].ul;
  $scope.server_add = st.sa;
  $scope.ser_dist = st.sd && parseInt(st.sd)+" km" || "";
  Object.values(speed_test_type).forEach(function(type){
   $("#speed_meter").changePosition(ST_PROGRESS.speed_test_res[type].dl,speednobe_id[type]);
  });
 };
 $scope.stop = function stop_speed_test(){
  $scope.set_default_values();
  ST_PROGRESS.engine_test_prog = false;
  ST_PROGRESS.speed_test_res.s = 0;//SPEEDTEST.test_done = true;
  $("#test_in_process").hide();
  //		$("#speed_meter").changePosition(0);
  if(!ST_PROGRESS.evaluate_env)$("#st_retest_btn").removeClass("disableBtn");
  //		$(".sts_download_result").css({color: 'gray', opacity: 0.5});
  //		$(".sts_upload_result").css({color: 'gray', opacity: 0.5});
 };
 $scope.check_capability = function(test){
  return Object.keys($scope.capabilities).some(function(item){ return test == item });
 };
 $scope.get_status = function(test){
  return $scope.capabilities[test] ? $scope.capabilities[test].status : undefined;
 };
 $scope.is_router_supported = function(test){
  return !SPEEDTESTDATA.capabilities.version||($scope.get_status(test) == router_supported_status);
 };
 $scope.check_multi_speed_test_capability = function(){
  $scope.is_wifi_test_failed = false;
  $scope.is_line_test_failed = false;
  $scope.st_problem_summary = "";
  $scope.st_usage_summary = "";
  $scope.st_hint = "";
  $scope.st_us_detailed_info = "";
  $scope.screen_link = "";
  $scope.server_add = "";
  $scope.ser_dist = "";
  $scope.is_wifi_test_capable = $scope.check_capability("wifi");
  $scope.is_line_test_capable = $scope.check_capability("line");
  $scope.is_e2e_test_capable = $scope.check_capability("e2e");
  $scope.wifi_supporting_router = $scope.is_router_supported("wifi");
  $scope.line_supporting_router = $scope.is_router_supported("line");
  $scope.e2e_supporting_router = $scope.is_router_supported("e2e");
  $scope.wifi_test_status_msg = _str(status_msg[$scope.get_status("wifi")]);
  $scope.line_test_status_msg = _str(status_msg[$scope.get_status("line")]);
  $scope.e2e_test_status_msg = _str(status_msg[$scope.get_status("e2e")]);
  $scope.is_p2p_test_capable = SPEEDTESTDATA.peer_2_peer_test;
  $scope.multi_speed_test = $scope.is_wifi_test_capable || $scope.is_line_test_capable ;
  $scope.is_wifi_download_capable = $scope.is_wifi_test_capable && $scope.capabilities.wifi.dl;
  $scope.is_wifi_upload_capable = $scope.is_wifi_test_capable && $scope.capabilities.wifi.ul;
  $scope.is_line_download_capable = $scope.is_line_test_capable && $scope.capabilities.line.dl;
  $scope.is_line_upload_capable = $scope.is_line_test_capable && $scope.capabilities.line.ul;
  if($scope.multi_speed_test && !SPEEDTESTDATA.peer_2_peer_test){
   $(".st_result_container").show();
   $(".st_server_data_container").hide();
   if($scope.is_wifi_test_capable) dial_hands++;
   if($scope.is_line_test_capable) dial_hands++;
  }else{
   $(".st_result_container").hide();
   $(".st_server_data_container").show();
   dial_hands = 1;
  }
  if(!(Object.keys($scope.capabilities).length && ($scope.wifi_supporting_router || $scope.line_supporting_router || $scope.e2e_supporting_router)))
   $("#st_retest_btn").addClass("disableBtn");
  else
    $("#st_retest_btn").removeClass("disableBtn");
 };
 $scope.router_con_status_update = function(){
  var routering_test_data = TESTRESULTS.getRouteringTestResults();
  L.trace("router_con_status_update--"+JSON.stringify(routering_test_data));
  var res = routering_test_data && routering_test_data.result;
  ST_PROGRESS.evaluate_env = true;
  switch(res){
   case "ok":
   $("#st_retest_btn").removeClass("disableBtn");
   $scope.st_usage_summary = "";
   ST_PROGRESS.evaluate_env = false;
   break;
   case "prog":
   $scope.st_usage_summary = $rootScope.strings.speed_test_environment_prepare;
   $("#st_retest_btn").addClass("disableBtn");
   break;
   case "warn":
   case "prob":
   $scope.st_usage_summary = routering_test_data && routering_test_data.details;
   $("#st_retest_btn").addClass("disableBtn");
   break;
   default :
   $scope.st_usage_summary = $rootScope.strings.speed_test_environment_prepare;
   L.trace("check_router_login_status--result not found--"+res);
  }
 };
 $scope.is_test_done = function(){
  if(Object.values($scope.cur_stt).some(function(x){return x})) return;
  L.trace("final test end event");
  ST_PROGRESS.engine_test_prog = false;
  ST_PROGRESS.speed_test_res.s = 0;
  $("#st_retest_btn").removeClass("disableBtn");
  $("#test_in_process").hide();
 };
 $rootScope.speed_test_process = function process_speedtest_event(event, payload){
  L.trace("process_speedtest_event--event>"+event+"--payload--"+JSON.stringify(payload));
  if(!payload) return;
  if(!payload.stt && payload.s == 3) { // all tests done
   L.trace("speed test - all done");
   var summary = payload.summary;
   if(summary) {
    Object.keys(summary).forEach(function(k){
     var dl = ST_UNITS.get_speed_Mbps(summary[k].dl);
     var ul = ST_UNITS.get_speed_Mbps(summary[k].ul);
     var s = !summary[k].s;
     var m = summary[k].m;
     switch(k){
     case "wifi":
     $scope.set_wifi_speed_status(dl,ul,s,m);
     break;
     case "e2e":
     case "p2p":
     $scope.set_total_internet_speed_status(dl,ul,s,m);
     break;
     case "line":
     $scope.set_line_speed_status(dl,ul,s,m);
     break;
    }
    if(!summary.s)$("#speed_meter").changePosition(dl,k);
    });
   }
   $scope.st_problem_summary = payload.ps && payload.ps.message|| "";
   $scope.st_usage_summary = payload.us && payload.us.message || payload.us|| "";
   $scope.st_hint = payload.ps && payload.ps.hint|| "";
   $scope.st_us_detailed_info = payload.us && payload.us.detailed|| "";
   $scope.screen_link = payload.ps && payload.ps.link|| "";
   if(ST_PROGRESS.update_available){
    var sc = SPEEDTESTDATA.capabilities;
    $scope.line_supporting_router = sc && sc.stt && sc.stt.line && sc.stt.line.status;
    $scope.is_line_download_capable = $scope.line_supporting_router && sc.stt.line.dl;
    $scope.is_line_upload_capable = $scope.line_supporting_router && sc.stt.line.ul;
   }
   return $scope.is_test_done();
  }
  if(!payload.t && payload.s == 3) { // specific test done
   L.trace("speed test - "+payload.stt+" - done");
   $scope.cur_stt[payload.stt] = false;
   $("#speed_meter").changePosition(ST_PROGRESS.speed_test_res[payload.stt].dl,speednobe_id[payload.stt]);
   return;
  }
  switch(payload.stt){ // status about either download or upload
   case "p2p" :
   prepare_speed_tests_results_array(event,payload.stt,payload,function(test_type,payload_obj){
    L.trace("speed test--case 1 ended");
    $scope.st_problem_summary = payload_obj.ps || "";
    $scope.st_usage_summary = payload_obj.us || "";
    $scope.set_total_internet_speed_status( ST_PROGRESS.speed_test_res[test_type].dl,ST_PROGRESS.speed_test_res[test_type].ul);
   },function(payload_obj){
    L.trace("speed test--case 1 failed--"+payload_obj.m);
    WTGDIALOG.open_simple_dialog(WTGDIALOG.gen_popup,{header: $rootScope.strings.alert, body: payload_obj.m , btn_one: $rootScope.strings.ok_btn});
    $scope.speed_test_fail();
    $scope.st_problem_summary = payload_obj.ps || "";
    $scope.st_usage_summary = payload_obj.us || "";
    $scope.stop();
   });
   break;
   case "line" :
   prepare_speed_tests_results_array(event,payload.stt,payload,function(test_type){
    L.trace("speed test--case 2 ended");
    $scope.set_line_speed_status(ST_PROGRESS.speed_test_res[test_type].dl,ST_PROGRESS.speed_test_res[test_type].ul,true);
   },function(payload_obj){
    L.trace("speed test--case 2 failed--"+payload_obj.m);
    $scope.set_line_speed_status("0.0","0.0",false,payload_obj.m);
   });
   break;
   case "e2e" :
   prepare_speed_tests_results_array(event,payload.stt,payload,function(test_type,payload_obj){
    L.trace("speed test--case 3 ended");
    $scope.st_problem_summary = payload_obj.ps || "";
    $scope.st_usage_summary = payload_obj.us || "";
    L.trace("speed test--ended--"+payload_obj.ps+"---"+payload_obj.us);
    $scope.set_total_internet_speed_status( ST_PROGRESS.speed_test_res[test_type].dl,ST_PROGRESS.speed_test_res[test_type].ul);
    if(ST_PROGRESS.speed_test_res[test_type].ul>0) {
     ST_PROGRESS.engine_test_prog = false;
     ST_PROGRESS.speed_test_res.s = 0;
    }
   },function(payload_obj){
    L.trace("speed test--case 3 failed");
    WTGDIALOG.open_simple_dialog(WTGDIALOG.gen_popup,{header: $rootScope.strings.alert, body: payload_obj.m , btn_one: $rootScope.strings.ok_btn});
    $scope.speed_test_fail();
    L.trace("speed test--failed--"+payload_obj.ps+"---"+payload_obj.us);
    $scope.st_problem_summary = payload_obj.ps || "";
    $scope.st_usage_summary = payload_obj.us || "";
    $scope.stop();
   });
   break;
   case "wifi" :
   prepare_speed_tests_results_array(event,payload.stt,payload,function(test_type){
    L.trace("speed test--speed test 4 ended");
    $scope.set_wifi_speed_status(ST_PROGRESS.speed_test_res[test_type].dl,ST_PROGRESS.speed_test_res[test_type].ul,true);
   },function(payload_obj){
    L.trace("speed test--case 4 failed--"+payload_obj.m);
    $scope.set_wifi_speed_status("0.0","0.0",false,payload_obj.m);
   });
   break;
   default:
   L.warn({e:event,p:payload},"event not handled-"+event);
  }
	};
  function prepare_speed_tests_results_array(event,test_type,payload,cb1,cb2){
   var val;
   switch(payload.t){
    case 'st' :
    switch(payload.s){
     case 3:
     if(cb1) cb1(test_type,payload);
     break;
     case 4:
     case 5:
     $("#speed_meter").changePosition(0,speednobe_id[test_type]);
     $scope.cur_stt[test_type] = false;
     $scope.is_test_done();
     if(cb2) cb2(payload);
     break;
     default :
     L.warn("status not handled-"+payload.s);
    }
    break;
    case 'dl' :
    val = payload.d && ST_UNITS.get_speed_Mbps(payload.d) || 0;
    switch(payload.s){
     case 1:
     $("#test_in_process").show();
     $scope.set_server_data(payload.sn,payload.dist);
     ST_PROGRESS.speed_test_res.sa = payload.sn;
     ST_PROGRESS.speed_test_res.sd = payload.dist;
     break;
     case 2:
     if(ST_PROGRESS.max_speed < val ) {
      ST_PROGRESS.max_speed = val+25;
     reset_gauge(val,$scope.capabilities);
     }
     $("#speed_meter").changePosition(val,speednobe_id[test_type]);
     $("#test_in_process").hide();
     break;
     case 3:
     ST_PROGRESS.speed_test_res[test_type].dl = val || 0.0;
     $("#speed_meter").changePosition(0,speednobe_id[test_type]);
     if(cb1) cb1(test_type,payload);
     break;
     case 4:
     case 5:
     $("#speed_meter").changePosition(0,speednobe_id[test_type]);
     $scope.cur_stt[test_type] = false;
     $scope.is_test_done();
     if(cb2) cb2(payload);
     break;
     default :
     L.warn("status not handled-"+payload.s);
    }
    break;
    case 'ul' :
    val = payload.d && ST_UNITS.get_speed_Mbps(payload.d) || 0;
    switch(payload.s){
     case 1:
     $("#test_in_process").show();
     break;
     case 2:
     $("#speed_meter").changePosition(val,speednobe_id[test_type]);
     $("#test_in_process").hide();
     break;
     case 3:
     ST_PROGRESS.speed_test_res[test_type].ul = val || 0.0;
     $("#speed_meter").changePosition(ST_PROGRESS.speed_test_res[test_type].dl,speednobe_id[test_type]);
     if(cb1) cb1(test_type,payload);
     $scope.cur_stt[test_type] = false;
     $scope.is_test_done();
     break;
     case 4:
     case 5:
     $("#speed_meter").changePosition(0,speednobe_id[test_type]);
     $scope.cur_stt[test_type] = false;
     $scope.is_test_done();
     if(cb2) cb2(payload);
     break;
     default :
     L.warn("status not handled-"+payload.s);
    }
    break;
    default:
    L.warn({e:event,p:payload},"event not handled");
   }
 }
 function reset_gauge(val,capabilities){
  var max = 50;
  var gauge_max_speed = 300;
  if((val > 0) && (val<= 100)) max = 50;
  else if((val > 101) && (val<= 250)) max = 150;
  else if((val > 251) && (val<= 400)){
   max = 200;
   gauge_max_speed = 400;
  }
  else if((val >401) && (val<= 600)){
   max = 300;
   gauge_max_speed = 600;
  }
  var scale = prepare_speed_test_scale(max,1,gauge_max_speed);
  if(!capabilities) capabilities = $scope.get_cap();
  $("#speed_meter").perform_speed_test({divFact:1,numbers:scale,maxVal:gauge_max_speed,speedNobes:dial_hands,capabilities:Object.keys(capabilities),gagueLabel:_str("speed_test_units_mbps")});
 }
 $scope.refresh_screen = function(capabilities,cb){
  SPEEDTESTDATA.capabilities = capabilities;
  if(ST_PROGRESS.engine_test_prog) {
   ST_PROGRESS.update_available = true;
   return;
  }
  $scope.capabilities = SPEEDTESTDATA.peer_2_peer_test ? SPEEDTESTDATA.testParams.stt : capabilities.stt;
  ST_PROGRESS.update_available = false;
  dial_hands = 1;
  var scale = prepare_speed_test_scale(50,1,300);
  if($scope.capabilities) {
   $scope.check_multi_speed_test_capability();
   $("#speed_meter").perform_speed_test({divFact:1,numbers:scale,maxVal:300,speedNobes:dial_hands,capabilities:Object.keys($scope.capabilities ),gagueLabel:_str("speed_test_units_mbps")});
  }
  //$scope.router_con_status_update();
  $scope.all_needles_to_default_state();
  if(cb)cb();
 };
 function prepare_speed_test_scale(max,min,gauge_max_speed){
  var scale_len = 6;
  var scaleAry =[0];
  var last_scale_values = [];
  if(!max) max =50;
  switch(max){
   case 50:
   scale_len = 6;
   last_scale_values = [100,200,gauge_max_speed];
   break;
   case 150:
   scale_len = 7;
   last_scale_values = [200,gauge_max_speed];
   break;
   case 200:
   scale_len = 7;
   last_scale_values = [300,gauge_max_speed];
   break;
   case 300:
   scale_len = 7;
   last_scale_values = [400,gauge_max_speed];
   break;
  }
  var r = Math.pow(max/min, 1/scale_len);
  for(var i=1; i<=scale_len ; i++) {
   var sn = Math.round(Math.pow(r,i)*min);
   if(sn>25) sn = Math.round(sn/5)*5;
   scaleAry[i] = sn;
  }
  if(last_scale_values.length) scaleAry = scaleAry.concat(last_scale_values);
  setTimeout(function(){_allow_swipe = true},1000);
  return scaleAry;
 }
 if(C11N.is_portal) load_content();
 }, false)
 .controller('speedTestResultsCtrl', function($scope, $rootScope,$timeout, ST_PROGRESS,WTGDIALOG,TESTRESULTS,ST_HISTORY,ST_UNITS,SPEEDTESTDATA,L) {
  var barChart;
  $scope.network_types = [{nid:"all_networks",str:_str("st_network_type_all"),bssid:""}];
  $scope.speed_test_types = [ {id:"peer_2_peer",tid:"p2p",value:_str("speed_test_type_p2p"),show:false},
  {id:"line_speed",tid:"line",value:_str("speed_test_type_provider"),show:false},
  {id:"e2e_speed",tid:"e2e",value:_str("speed_test_type_total"),show:false},
  {id:"wifi_speed",tid:"wifi",value:_str("speed_test_type_router"),show:false}];
  $scope.speed_types = [ {id:"down_up_speed",tid:1,value:_str("id_speed_test_download") +"/"+_str("id_speed_test_upload"),show:true},
  {id:"download_speed",tid:2,value:_str("id_speed_test_download"),show:true},
  {id:"upload_speed",tid:3,value:_str("id_speed_test_upload"),show:true}];
  $scope.selectedValue = "";
  $scope.selected_type = "e2e";
  $scope.speed_type = 1;
  $scope.selected_network_id = SPEEDTESTDATA.history ? SPEEDTESTDATA.networkId : "all_networks";
  $scope.bssid = SPEEDTESTDATA.history ? SPEEDTESTDATA.bssid : "";
  $scope._index = 0;
  $scope.network_index = 0;
  $scope.speed_index = 0;
  $scope.orderByField = 'ts';
  $scope.reverseSort = true;
  $scope.graph_visible = true;
  $scope.no_chart_data = $rootScope.strings.speed_test_no_data;
  $scope.target_label = $rootScope.strings.speed_test_target_str;
  $scope.type_label = $rootScope.strings.speed_test_source_str;
  $scope.network_type_prefix = $rootScope.strings.speed_test_network_type_prefix;
  $scope.st_res_filter_ary = [];
  $scope.dev_icon = C11N.root_path +"speed-test/images/phone_icon.svg";
  var download_label = $rootScope.strings.id_speed_test_download;
  var upload_label = $rootScope.strings.id_speed_test_upload;
  $scope.date_label = $rootScope.strings.speed_test_date_label;
  $scope.st_results = [];
  $scope.get_network_type = function(text){
   text = $scope.network_type_prefix + " "+ text;
   if (text.length > 40) text = text.substring(0, 39) + '...';
   return text;
  };
  $scope.getData = function(dl,ul){
  switch($scope.speed_type){
   case 1 : /* TODO: magic */
    ul = ST_UNITS.get_speed_Mbps(ul);
    dl = ST_UNITS.get_speed_Mbps(dl);
    return (dl||ul)?(dl + " / " + ul):"";
   case 2 : /* TODO: magic */
    return ST_UNITS.get_speed_Mbps(dl);
   case 3 : /* TODO: magic */
    return ST_UNITS.get_speed_Mbps(ul);
  }
 };
 $scope.getTimeWithDate = function(t){
  return DATE_UTIL.getTimeStampForUI(t,true);
 };
 $scope.onSwipeStart = function(){
  _allow_swipe = false;
 };
 $scope.onOutsideTouch = function(){
  _allow_swipe = true;
 };

  function fitCanvasToContainer(id){
   var canvas = $("#"+id).get(0);
   canvas.style.width='100%';
   canvas.style.height='100%';
   canvas.width = canvas.offsetWidth;
   canvas.height = canvas.offsetHeight;
  }

  function draw_graphical_view(type){
   var dl_array= [];
   var ul_array =[];
   var time_array = [];
   $scope.st_res_filter_ary = [];
   var caps = ["e2e"];
   var snid = $scope.selected_network_id;

   $scope.speed_test_types.forEach(function(stypeObj){stypeObj.show = false});
   $scope._index = $scope.speed_test_types.findIndex(function(x){ return (x.tid == $scope.selected_type)});
   $scope.speed_index = $scope.speed_types.findIndex(function(x){ return (x.tid == $scope.speed_type)});
   $scope.bssid = $scope.network_types[$scope.network_index] && $scope.network_types[$scope.network_index].bssid ;

   $scope.st_results.forEach(function(item){
    if(!item || !(item.dl || item.ul)) return null;
    if((snid == "all_networks") || (snid && (item.network_id == snid) && (item.bssid == $scope.bssid)) || (!snid && (item.bssid == $scope.bssid))){
     if(type == item.type_id){
      if(time_array.length < 100){
       if(($scope.speed_type == 1) || ($scope.speed_type == 2))dl_array.push(ST_UNITS.get_speed_Mbps(item.dl));
       if(($scope.speed_type == 1) || ($scope.speed_type == 3))ul_array.push(ST_UNITS.get_speed_Mbps(item.ul));
       time_array.push($scope.getTimeWithDate(item.ts));
      }
      $scope.st_res_filter_ary.push(item);
     }
     if(caps.findIndex(function(key){return (key == item.type_id)}) == -1) caps.push(item.type_id);
    }
   });
   $scope.speed_test_types.forEach(function(stypeObj){caps.forEach(function(key){if(key == stypeObj.tid) stypeObj.show = true;})});
   $scope.speed_types.forEach(function(st_obj){
    if(st_obj.id != "down_up_speed") st_obj.show = false;
    $scope.st_res_filter_ary.forEach(function(k){
      if("download_speed" == st_obj.id && k.dl)st_obj.show = true;
      if("upload_speed" == st_obj.id && k.ul)st_obj.show = true;
      });
   });
   if(!time_array.length) {$scope.graph_visible = false}
   $scope.speed_test_ui = false;
   var fSize = parseInt($(".st_graph_canvas_parent").css('font-size').slice(0, -2));
   var w = $(document.body).innerWidth() || getScreenWidth();
   if(!fSize) fSize = (w > 500) ? ((w*12)/500) : 12 ;
   //			this code block for graph scrolling. currently we removed it for testing
   /* var can_wd =  w*.96;
   var single_bar_width = w/5;
   var total_width= single_bar_width*dl_array.length;
   total_width = can_wd > total_width ? can_wd : total_width;
   $("#canvas_inner").css("width",total_width+"px");*/
   var stCanvas = $("#speedTestChart").get(0);
   var downloadData = {
    label: $rootScope.strings.id_speed_test_download,
    data: dl_array,
    backgroundColor:  'rgba(0, 128, 0, 0.9)',
    borderWidth: 0,
   };
   var uploadData = {
    label:  $rootScope.strings.id_speed_test_upload,
    data: ul_array,
    backgroundColor: 'rgba(144, 238, 144, 0.9)',
    borderWidth: 0,
   };
   var st_chart_data = {
    labels: time_array,
    datasets: [downloadData, uploadData]
   };
   var chartOptions = {
    legend: {
     display: true,
     position:'bottom'
    },
    scales: {
     yAxes: [{
      scaleLabel: {
       display: true,
       fontColor: '#00000',
       fontSize :fSize,
       fontStyle: "bold",
       labelString:$rootScope.strings.speed_test_graph_yaxis_label
      },
      gridLines: {
       display:false
      },
      stacked: true
     }],
     xAxes: [{
      scaleLabel: {
       display: true,
       fontColor: '#00000',
       fontSize :fSize,
       fontStyle: "bold",
       labelString: $rootScope.strings.speed_test_graph_xaxis_label
      },
      ticks: {
       //stepSize: ,
       //								unitStepSize: 5,
       autoskip: true,
       fontSize :0,
       callback: function (value) {
        return value.split(/<br\s*\/?>/i);
       }
      },
      gridLines: {
       display:false
      },
      stacked: true
     }],
    }
   };
   barChart && barChart.destroy(); // destroy previous chart
   barChart = new Chart(stCanvas, {
    type: 'bar',
    data: st_chart_data,
    options: chartOptions
   });
  }
  $scope.on_select_speed_test_type = function(item/*,ind*/){
   $scope.selected_type = item.tid;
   $scope.speed_type = 1;
   $scope.graph_visible = true;
   // this time out for graph design animation
   $timeout(function(){draw_graphical_view($scope.selected_type)},0);
  };
  $scope.on_select_network_type = function(item,ind){
   $scope.network_index = ind;
   $scope.selected_network_id = $scope.network_types[ind].nid;
   $scope.selected_type = "e2e";
   $scope.speed_type = 1;
   $scope.graph_visible = true;
   $timeout(function(){draw_graphical_view($scope.selected_type)},0);
  };
  $scope.on_select_speed_type = function(item/*,ind*/){
   $scope.speed_type = item.tid;
   $scope.graph_visible = true;
   // this time out for graph design animation
   $timeout(function(){draw_graphical_view($scope.selected_type)},0);
  };
  $scope.select_user_location = function(){
   if(!C11N.nw_location) return;
   WTGDIALOG.open_simple_dialog(WTGDIALOG.locationListCtrl, { header: $rootScope.strings.select_location_btn,
    body:  "",btn_two:$rootScope.strings.cancel_btn, btn_one: $rootScope.strings.ok_btn,
    controller: "showRadio",
    cb_two: function(){
     L.trace('-cbone-no-');
    },
    cb_one: function(val){
     L.trace('-cbone-yes-'+val);
     NativeAPI.call_engine('network.location.save',{n:val});
    }
   });
  };
  $scope.show_wifi_performance_data = function(item){
   //L.trace("show_wifi_performance_data - "+JSON.stringify(item));
   if(item.type_id=='line' || item.type_id=='p2p') return;
   $rootScope.showBusyScreen("",_str("busy_screen_message"),"");
   var d = {context: "speedTest",title:_str("str_wifi_performance_data"),data:[
               {header: _str("network_list_signal"),content:(item.s+item.u || "NA")},
               {header: _str("wifi_network_list_band"),content:item.b || "NA"},
               {header: _str("wifi_network_list_channel"),content:item.c || "NA"},
               {header: _str("str_congestion"),content:item.o || "NA"}]};
   //L.trace("data - "+JSON.stringify(d));
   ShowScreen('DetailsScreen',"/"+encodeURIComponent(JSON.stringify(d)));
  };
  $scope.order = function (name) {
   $scope.reverseSort = !$scope.reverseSort;
   $scope.orderByField = name;
  };
  $scope.getLabel = function(){
   switch($scope.speed_type){
    case 1 :
    return download_label +' /<br>'+ upload_label +'('+$scope.slider_units+')';
    case 2 :
    return download_label +' <br>('+$scope.slider_units+')';
    case 3 :
    return $scope.upload_label +' <br>('+ $scope.slider_units+')';
   }
  };
  fitCanvasToContainer("speedTestChart");
  $scope.st_results = [];
  $("#sts_results").addClass("st_tab_select");
  $("#sts_speed_test").removeClass("st_tab_select");
  $rootScope.showBusyScreen("",_str("busy_screen_message"),"");
  ST_HISTORY.fetch(function(err, sth) {
   if(err) {
    L.error("error while retrieving test history");
    $scope.noHistoryFound = $rootScope.strings.no_history_found;
   }
   else {
    $scope.noHistoryFound = "";
    if(sth&&sth.olddata) {
     var history = sth.history;
     history.forEach(function(t) {
      var res_data = t && t.result_data && JSON.parse(t.result_data) || "";
      Object.keys(res_data).forEach(function(key){
       var r = res_data[key];
       if(r && r.dl && r.ul)
       $scope.st_results.push({"network_id":r.nid||"","dl" : r.dl,"ul" : r.ul, "ts": t.ts,"type_id":key||"" ,"net_name":r.net_name||$rootScope.strings.speed_test_unknown_network,"ser_name":r.name||""});
      });
     });
    }
    else {
    //L.trace("sth - "+JSON.stringify(sth));
    for(var type in sth) {
     //L.trace("type - "+type);
     for(var id in sth[type]) {
      //L.trace("id - "+id);
      var rd = (type=='p2p')?(sth[type][id] && JSON.parse(sth[type][id])):(sth[type][id] && sth[type][id].result_data && JSON.parse(sth[type][id].result_data));
      //L.trace("rd - "+rd);
      //L.trace("rd - "+JSON.stringify(rd));
      var tmp="";
      if(rd && (rd.dl || rd.ul)) {
       tmp = {"network_id":rd.nid||"","ts":sth[type][id].ts||id,"type_id":type||"","net_name":rd.net_name||_str("speed_test_unknown_network"),
        "ser_name":(rd.server&&rd.server.name)||"","bssid": rd.bssid||"",s:rd.s,c:rd.c,b:rd.b,o:rd.o,u:rd.u};
       if(rd.dl && rd.dl.max_speed) tmp.dl = rd.dl.max_speed;
       if(rd.ul && rd.ul.max_speed) tmp.ul = rd.ul.max_speed;
      }
      $scope.st_results.push(tmp);
     }
    }
    $scope.st_results.forEach(function(x){
     if(!x) return;
     var index = $scope.network_types.findIndex(function(obj){return ((obj.nid == x.network_id) && (obj.bssid == x.bssid))});
     if(index == -1) $scope.network_types.push({nid:x.network_id ,str:x.net_name,bssid: x.bssid});
    });
    $scope.network_index = $scope.network_types.findIndex(function(x){ return (x.nid == $scope.selected_network_id && x.bssid == $scope.bssid )});
    draw_graphical_view($scope.selected_type);
   }
   $rootScope.hideBusyScreen();
   }
  });
 }, false);
 export var speed_test = {
  process :  function process_speedtest_event(event, payload){
   var rscope = angular.element($('#appScreensContainer')).scope();
   if(!rscope) return;
   rscope.$apply(function() { rscope.speed_test_process && rscope.speed_test_process(event, payload)});
  },
  refresh_screen : function(capabilities){
   var $scope = angular.element($('#speedTestScreen')).scope();
   if(!$scope) return;
   $scope.$apply(function() { $scope.refresh_screen(capabilities) });
  },
  stop : function stop_speed_test() {
   var $scope = angular.element($('#speedTestScreen')).scope();
   $scope.stop();
  }
 };
/* vim:set ts=8 sw=2 expandtab: */
